import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// import overlayFactory from 'react-bootstrap-table2-overlay';
import BootstrapTable from 'react-bootstrap-table-next';
import { uuid } from 'uuidv4';
import Pagination from 'components/v2/PaginationV2';
import { withTranslation } from 'react-i18next';
import { exceptionReporterFormatter, customActionsFormatter, currencyFormatter, customerFormatter, dateFormatter, dateTimeFormatter, getEntityFormatter, equipmentListFormatter, headerFormatter, locationFormatter, objectIdTimestampFormatter, priceFormatter, referenceNumberFormatter, statusFormatter, accessorialStatusFormatter, defaultFormatter, tagsFormatter, rolesFormatter, slaFormatter, booleanFormatter, datetimeRangeFormatter, loadDetailsFormatter, credentialFormatter, genericFormatter, InvoiceFormatter, documentsFormatter, serviceWatchFormatter, shipperCostFormatter, carrierPayoutFormatter, masterAccountFormatter, } from './formatters';
const MAX_BUTTONS = 15;
class DataList extends Component {
    formatColumns() {
        const hiddenColumns = this.props.hiddenColumns || [];
        return this.props.columns.map((column) => {
            if (!this.props.showHeaders) {
                column.headerStyle = { display: 'none' };
            }
            else if (column.headerStyle && column.headerStyle.display) {
                // Somewhere deep, this impacts rendering multiple data list with
                // header styles
                delete column.headerStyle.display;
            }
            if (this.props.noBorders) {
                column.style = { border: 0 };
            }
            if (!column.headerFormatter) {
                column.headerFormatter = headerFormatter;
            }
            if (!column.formatter) {
                switch (column.type) {
                    case 'generic':
                        column.formatter = genericFormatter;
                        break;
                    case 'currency':
                        column.formatter = currencyFormatter;
                        break;
                    case 'price':
                        column.formatter = priceFormatter;
                        break;
                    case 'entity':
                        column.formatter = getEntityFormatter(column.entityType);
                        break;
                    case 'customer':
                        column.formatter = customerFormatter;
                        break;
                    case 'credentials':
                        column.formatter = credentialFormatter;
                        break;
                    case 'master_account':
                        column.formatter = masterAccountFormatter;
                        break;
                    case 'service_watch':
                        column.formatter = serviceWatchFormatter;
                        break;
                    case 'loaddetails':
                        column.formatter = loadDetailsFormatter;
                        break;
                    case 'dateWithTime':
                        column.formatter = dateTimeFormatter;
                        break;
                    case 'datetime':
                        column.formatter = dateFormatter;
                        break;
                    case 'reference_number':
                        column.formatter = referenceNumberFormatter;
                        break;
                    case 'equipments':
                        column.formatter = equipmentListFormatter;
                        break;
                    case 'location':
                        column.formatter = locationFormatter;
                        break;
                    case 'status':
                        column.formatter = statusFormatter;
                        break;
                    case 'accessorial_status':
                        column.formatter = accessorialStatusFormatter;
                        break;
                    case 'objectId':
                        column.formatter = objectIdTimestampFormatter;
                        break;
                    case 'customActions':
                        column.formatter = customActionsFormatter(column.formatExtraData);
                        break;
                    case 'tags':
                        column.formatter = tagsFormatter;
                        break;
                    case 'reporter':
                        column.formatter = exceptionReporterFormatter;
                        break;
                    case 'roles':
                        column.formatter = rolesFormatter;
                        break;
                    case 'sla':
                        column.formatter = slaFormatter;
                        break;
                    case 'boolean':
                        column.formatter = booleanFormatter;
                        break;
                    case 'daterange':
                        column.formatter = datetimeRangeFormatter;
                        break;
                    case 'invoice':
                        column.formatter = InvoiceFormatter;
                        break;
                    case 'documents':
                        column.formatter = documentsFormatter;
                        break;
                    case 'shipper_cost':
                        column.formatter = shipperCostFormatter;
                        break;
                    case 'carrier_payout':
                        column.formatter = carrierPayoutFormatter;
                        break;
                    case 'raw':
                        break;
                    default:
                        column.formatter = defaultFormatter;
                        break;
                }
            }
            column.hidden = hiddenColumns.includes(column.dataField);
            return column;
        });
    }
    render() {
        const columns = this.formatColumns();
        const selectRow = this.props.select
            ? {
                mode: this.props.selectMode || 'checkbox',
                selected: this.props.selected,
                onSelect: this.props.onSelect,
                onSelectAll: this.props.onSelectAll,
                hideSelectColumn: this.props.hideSelectColumn,
                clickToSelect: this.props.clickToSelect,
                classes: 'selected',
            }
            : undefined;
        const rowClasses = this.props.shouldRowHighlight
            ? this.props.shouldRowHighlight
            : null;
        const rowStyle = this.props.noBorders
            ? {
                border: 0,
                bottomBorder: 1,
            }
            : null;
        const data = (this.props.data || []).map((obj) => (Object.assign(Object.assign({}, obj), { uuid: uuid() })));
        const { t } = this.props;
        return (React.createElement("div", null,
            !this.props.hideTopPagination &&
                this.props.paginate &&
                this.props.pages >= 1 && (React.createElement(Pagination, { first: true, last: true, total: this.props.total, page: this.props.page, onPageClick: this.props.onPaginationSelect, perPage: this.props.perPage })),
            React.createElement("div", { className: "table-hscrolling" },
                React.createElement(BootstrapTable, { remote: this.props.remote || {}, onTableChange: this.props.onTableChange, keyField: this.props.keyField || '_id', striped: this.props.striped, hover: this.props.hover, data: data || this.props.data, columns: columns, selectRow: selectRow, bordered: false, noDataIndication: this.props.noDataIndication || t('NO_DATA_FOUND'), rowStyle: rowStyle, rowClasses: rowClasses, condensed: this.props.condensed, options: this.props.options })),
            this.props.paginate && this.props.pages > 1 && (React.createElement(Pagination, { first: true, last: true, total: this.props.total, page: this.props.page, onPageClick: this.props.onPaginationSelect, perPage: this.props.perPage }))));
    }
}
DataList.propTypes = {
    condensed: PropTypes.bool,
    hover: PropTypes.bool,
    clickToSelect: PropTypes.bool,
    columns: PropTypes.array,
    data: PropTypes.array,
    hiddenColumns: PropTypes.array,
    hideSelectColumn: PropTypes.bool,
    maxButtons: PropTypes.number,
    noBorders: PropTypes.bool,
    noDataIndication: PropTypes.string,
    onPaginationSelect: PropTypes.func,
    onSelect: PropTypes.func,
    onSelectAll: PropTypes.func,
    page: PropTypes.number,
    pages: PropTypes.number,
    paginate: PropTypes.bool,
    select: PropTypes.bool,
    selected: PropTypes.array,
    showHeaders: PropTypes.bool,
    striped: PropTypes.bool,
    options: PropTypes.object,
};
DataList.defaultProps = {
    data: [],
    hiddenColumns: [],
    options: {},
};
export default withTranslation()(DataList);
